export default {
  lang: 'tr',
  dir: 'ltr',
  common: {
    ok: 'Tamam',
    cancel: 'İptal',
    key_backspace: 'Gerisilme',
    key_del: 'Delete',
    key_down: 'Aşağı',
    key_up: 'Yukarı',
    more_opts: 'Daha fazla',
    url: 'URL',
    width: 'En',
    height: 'Boy'
  },
  misc: {
    powered_by: 'Geliştiren'
  },
  ui: {
    toggle_stroke_tools: 'Göster/Gizle çizim araçları',
    palette_info: 'Dolgu rengini değiştirmek için tıklayın, shift-click ile çizgi rengini değiştirin',
    zoom_level: 'Yakınlık seviyesini değiştirin',
    panel: 'Panel',
    panel_action: 'Yan paneli açmak için tıklayın',
    quality: 'Kalite:',
    pathNodeTooltip: 'Düğümü taşıyarak hareket ettirin. Düğüme tıklayarak kesit türünü değiştirin',
    pathCtrlPtTooltip: 'denetleme noktasını sürükleyerek eğriyi değiştirin',
    pick_stroke_paint_opacity: 'Çizgi Rengi ve Saydamlık düzeyi seçin',
    pick_fill_paint_opacity: 'Dolgu Rengi ve Saydamlık düzeyi seçin',
    group_identify_label: 'Grup kimlik etiketi',
    export_type_label: 'Dışa aktarma için resim seçin:'
  },
  properties: {
    id: 'Öge kimlik numarası',
    fill_color: 'Dolgu rengini değiştir',
    stroke_color: 'Çizgi rengini değiştir',
    stroke_style: 'Çizgi stilini değiştir',
    stroke_width: 'Çizgi kalınlığını 1 birim değiştir, shift-click ile 0.1 birim değiştir',
    pos_x: 'X koordinatı değiştir',
    pos_y: 'Y koordinatı değiştir',
    linecap_butt: 'ÇizgiUcu: Butt',
    linecap_round: 'ÇizgiUcu: Yuvarlak',
    linecap_square: 'ÇizgiUcu: Kare',
    linejoin_bevel: 'ÇizgiBirleşim: Kabartma',
    linejoin_miter: 'ÇizgiBirleşim: Miter',
    linejoin_round: 'ÇizgiBirleşim: Yuvarlak',
    angle: 'Döndürme açısını değiştir',
    blur: 'Gaussian bulanıklık değerini değiştir',
    opacity: 'Seçilen ögenin saydamlığını değiştir',
    circle_cx: 'Çemberin cx koordinatını değiştir',
    circle_cy: 'Çemberin cy koordinatını değiştir',
    circle_r: 'Çemberin yarıçapını değiştir',
    ellipse_cx: 'Elipsin cx koordinatını değiştir',
    ellipse_cy: 'Elipsin cy koordinatını değiştir',
    ellipse_rx: 'Elipsin x yarıçapını değiştir',
    ellipse_ry: 'Elipsin y yarıçapını değiştir',
    line_x1: 'Çizginin başlangıç x değerini değiştir',
    line_x2: 'Çizginin bitiş x değerini değiştir',
    line_y1: 'Çizginin başlangıç y değerini değiştir',
    line_y2: 'Change line\'s ending y coordinate',
    rect_height: 'Üçgenin yüksekliğini değiştir',
    rect_width: 'Üçgenin enini değiştir',
    corner_radius: 'Üçgenin Köşe Yarıçapını değiştir',
    image_width: 'Resmin enini değiştir',
    image_height: 'Resmin boyunu değiştir',
    image_url: 'URL değiştir',
    node_x: 'Düğümün x koordinatını değiştir',
    node_y: 'Düğümün y koordinatını değiştir',
    seg_type: 'Kesit tipini değiştir',
    straight_segments: 'Düzgün',
    curve_segments: 'Eğri',
    text_contents: 'Metin içeriğini değiştir',
    font_family_label: 'Font:',
    font_family: 'Font Ailesini Değiştir',
    font_size: 'Font boyutunu değiştir',
    bold: 'Kalın Metin',
    text_decoration_underline: 'Altıçizili',
    text_decoration_linethrough: 'Ortaçizili',
    text_decoration_overline: 'Üstçizili',
    italic: 'Italic Metin',
    text_anchor_start: 'Metni başa hizala',
    text_anchor_middle: 'Metni ortaya hizala',
    text_anchor_end: 'Metni sona hizala',
    text_letter_spacing: 'Harf boşluklarını değiştir',
    text_word_spacing: 'Kelime arası boşlukları değiştir',
    text_length: 'Metnin içerisine çizileceği boşluğun miktarını belirmeye yarar',
    text_length_adjust: 'Uzunluk Ayarla',
    text_length_adjust_spacing: 'Boşluk',
    text_length_adjust_spacing_and_glyphs: 'Boşluk & Glyphs',
    r_label: 'r',
    x_label: 'x',
    y_label: 'y',
    x1_label: 'x1',
    y1_label: 'y1',
    x2_label: 'x2',
    y2_label: 'y2',
    rx_label: 'rx',
    ry_label: 'ry',
    cx_label: 'cx',
    cy_label: 'cy',
    w_label: 'w',
    h_label: 'h',
    id_label: 'id',
    class_label: 'class',
    label: 'etiket',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Seçenekleri ve SVG içeriğini yerel olarak sakla',
    prefs_only: 'Sadece seçenekleri yerel olarak sakla',
    no_prefs_or_content: 'SVG içeriğini ya da seçenekleri yerel olarak saklama!',
    jgraduate_pad: 'Dolgula',
    jgraduate_reflect: 'Yansıt',
    jgraduate_repeat: 'Tekrarla'
  },
  tools: {
    main_menu: 'Ana Menu',
    bkgnd_color_opac: 'Arka plan rengini/saydamlığını ayarla',
    connector_no_arrow: 'Düz bağlantı',
    fitToContent: 'İçeriğe sığdır',
    fit_to_all: 'Tüm içeriğe sığdır',
    fit_to_canvas: 'canvas\'a sığdır',
    fit_to_layer_content: 'Kayman içeriğine sığdır',
    fit_to_sel: 'Seçime sığdır',
    align_relative_to: 'Şuna göre hizala...',
    relativeTo: 'şuna göre:',
    page: 'sayfa',
    largest_object: 'enbüyük nesne',
    selected_objects: 'seçili nesneler',
    smallest_object: 'enküçük nesne',
    export_img: 'Dışa aktar',
    import_doc: 'SVG içe aktar',
    align_to_page: 'Ögeyi Sayfaya Hizala',
    align_bottom: 'Alta Hizala',
    align_center: 'Merkeze Hizala',
    align_left: 'Sola Hizala',
    align_middle: 'Ortaya Hizala',
    align_right: 'Sağa Hizala',
    align_top: 'Üste Hizala',
    mode_select: 'Seçim Aracı',
    mode_fhpath: 'Kalem Aracı',
    mode_line: 'Çizgi Aracı',
    mode_rect: 'Dörtgen Aracı',
    mode_square: 'Kare Aracı',
    mode_fhrect: 'Serbest Dörtgen Aracı',
    mode_ellipse: 'Elips',
    mode_circle: 'Çember',
    mode_fhellipse: 'Serbest Elips',
    mode_path: 'Path Aracı',
    mode_text: 'Metin Aracı',
    mode_image: 'Resim Aracı',
    mode_zoom: 'Yakınlaştırma Aracı',
    no_embed: 'NOT: Bu resim içe gömülemiyor. Bu Path e bağlı olarak görüntülenecek',
    undo: 'Gerial',
    redo: 'Yinele',
    tool_source: 'Kaynağı Düzenle',
    wireframe_mode: 'Çizgi Mod',
    clone: 'Öge(ler)i Çoğalt',
    del: 'Öge(ler)i Sil',
    group_elements: 'Ögeleri Grupla',
    make_link: '(hiper) Link Oluştur',
    set_link_url: 'Bağlantı URL si ata(boş bırak ya da kaldır)',
    to_path: 'Path\'e dönüştür',
    reorient_path: 'Path yeniden yönlendir',
    ungroup: 'Ögelerin Grubunu çöz',
    docprops: 'Belge Seçenekleri',
    editor_homepage: 'SVG-Edit Ana Sayfası',
    move_bottom: 'Alta gönder',
    move_top: 'Öne gönder',
    node_clone: 'Düğüm Klonla',
    node_delete: 'Düğüm Klonla',
    node_link: 'Denetim Noktalarını Bağla',
    add_subpath: 'Alt Path ekle',
    openclose_path: 'Aç/Kapa Alt Path',
    source_save: 'Değişiklikleri Kaydet',
    cut: 'Kes',
    copy: 'Kopyala',
    paste: 'Yapıştır',
    paste_in_place: 'Yerine Yapıştır',
    delete: 'Sil',
    group: 'Grupla',
    move_front: 'En Öne Getir',
    move_up: 'Bir Öne Getir',
    move_down: 'Bir Arkaya Gönder',
    move_back: 'En Arkaya Gönder',
    tool_unlink_use: 'Ana nesneye bağını kopar (bağımsız yap)',
    ellipse_circle_tool: 'Elips/Çember Aracı',
    square_rect_tool: 'Kare/Dörtgen Aracı',
    remember_this_choice: 'Bu seçenek hatırlansın mı?',
    remember_this_choice_title: 'Bu seçenek seçilirse, seçiminiz hatırlanacak biçimde URL değiştirilecek.'
  },
  layers: {
    layer: 'Katman',
    layers: 'Katmanlar',
    del: 'Katmanı Sil',
    move_down: 'Katmanı Aşağı Taşı',
    new: 'Yeni Katman',
    rename: 'Katmanı Yeniden Adlandır',
    move_up: 'Katmanı Üste Taşı',
    dupe: 'Katmanı Çoğalt...',
    merge_down: 'Aşağı Birleştir',
    merge_all: 'Tümünü Birleştir',
    move_elems_to: 'Ögeleri şuraya taşı:',
    move_selected: 'Seçilen ögeleri farklı katmana taşı'
  },
  config: {
    image_props: 'Resim Özellikleri',
    doc_title: 'Başlık:',
    doc_dims: 'Canvas Boyutları',
    included_images: 'Dahili Resimler',
    image_opt_embed: 'Veriyi Göm(local files)',
    image_opt_ref: 'Use file reference',
    editor_prefs: 'Editör Seçenekleri',
    language: 'Dil:',
    background: 'Editör Arkaplanı',
    editor_img_url: 'Resim URL:',
    editor_bg_note: 'Not: Arkaplan resimle kaydedilmeyecek!',
    select_predefined: 'Select predefined:',
    units_and_rulers: 'Birimler & Cetveller',
    show_rulers: 'Cetvelleri Göster',
    base_unit: 'Temel Birim:',
    grid: 'Izgara',
    snapping_onoff: 'Hizalama Yardımı Aç/Kapa',
    snapping_stepsize: 'Hizalama Yardım Adımı:',
    grid_color: 'Izgara Rengi:',
    done: 'Kaydedildi',
    change_xxx_color: 'xxx rengini değiştir',
    pick_paint_opavity: 'Renk ve saydamlık için yeni bir değer{{newValue}}',
    open_color_picker: 'Renk Seçiciyi Açmak için Tıklayın',
    jpicker_title: 'Renk Seçmek için işaretçileri Sürükleyin',
    jpicker_new_color: 'yeni',
    jpicker_current_color: 'mevcut',
    jpicker_tooltip_colors_new_color: 'Yeni Renk - &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Asıl renge dönmek için tıklayın',
    jpicker_tooltip_buttons_ok: 'Renk seçitine ekle',
    jpicker_tooltip_buttons_cancel: 'Vazgeç asıl renge dön',
    jpicker_tooltip_hue_radio: '&ldquo;Hue&rdquo; Renk Modu Ayarla',
    jpicker_tooltip_hue_textbox: '&ldquo;Hue&rdquo; değeri (0-360&deg;)',
    jpicker_tooltip_saturation_radio: '&ldquo;Doygunluk&rdquo; Renk Modu Ayarla',
    jpicker_tooltip_saturation_textbox: '&ldquo;Doygunluk&rdquo; Değeri(0-100%)',
    jpicker_tooltip_value_radio: '&ldquo;Beyazlık&rdquo; Renk Modu Ayarla',
    jpicker_tooltip_value_textbox: '&ldquo;Beyazlık&rdquo; Değeri (0-100%)',
    jpicker_tooltip_red_radio: '&ldquo;Kırmızı&rdquo; Renk Modu Ayarla',
    jpicker_tooltip_red_textbox: '&ldquo;Kırmızı&rdquo; Değeri (0-255)',
    jpicker_tooltip_green_radio: '&ldquo;Yeşil&rdquo; Renk Modu Ayarla',
    jpicker_tooltip_green_textbox: '&ldquo;Yeşil&rdquo; Değeri (0-255)',
    jpicker_tooltip_blue_radio: '&ldquo;Mavi&rdquo; Renk Modu',
    jpicker_tooltip_blue_textbox: '&ldquo;Mavi&rdquo; Değeri (0-255)',
    jpicker_tooltip_alpha_radio: '&ldquo;Saydamlık&rdquo; Renk Modu Ayarla',
    jpicker_tooltip_alpha_textbox: '&ldquo;Saydamlık&rdquo; Değeri (0-100)',
    jpicker_tooltip_hex_textbox: '&ldquo;Hex&rdquo; Renk Modu Ayarla (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: '&ldquo;Hex&rdquo; Değeri (#00-#ff)',
    jgraduate_solid_color: 'Tek Renk',
    jgraduate_linear_gradient: 'Doğrusal Gradyan',
    jgraduate_radial_gradient: 'Döngüsel Gradyan',
    jgraduate_begin_point: 'Başlangıç Noktası',
    jgraduate_enter_starting_x: 'x için 0.0 ve 1.0 arasında başlangıç değeri girin',
    jgraduate_enter_starting_y: 'y için 0.0 ve 1.0 arasında başlangıç değeri girin',
    jgraduate_end_point: 'Bitiş Noktası',
    jgraduate_enter_ending_x: 'x için 0.0 ve 1.0 arasında bitiş değeri girin',
    jgraduate_enter_ending_y: 'y için 0.0 ve 1.0 arasında bitiş değeri girin',
    jgraduate_center_point: 'Merkez Noktası',
    jgraduate_enter_value_x: 'x için 0.0 ve 1.0 arasında değer girin',
    jgraduate_enter_value_y: 'y için 0.0 ve 1.0 arasında değer girin',
    jgraduate_focal_point: 'Odak Noktası',
    jgraduate_match_center: 'Merkezle eşleştir:',
    jgraduate_enter_focal_x: 'x için 0.0 ve 1.0 arasında değer girin',
    jgraduate_enter_focal_y: 'y için 0.0 ve 1.0 arasında değer girin',
    jgraduate_spread_method: 'Yayılım Metodu',
    jgraduate_radius: 'Yarıçap:',
    jgraduate_set_radius: 'Yarıçapı ayarlamak için tıklayın',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Ellip ayarlamak için tıklayın',
    jgraduate_angle: 'Açı:',
    jgraduate_set_angle: 'Açıyı ayarlamak için tıklayın',
    jgraduate_deg: 'derece:',
    jgraduate_opac: 'Şeffflık:',
    jgraduate_set_opac: 'Şeffaflığı ayarlamak için tıklayın'
  },
  notification: {
    invalidAttrValGiven: 'Verilen değer geçersiz',
    noContentToFitTo: 'Kendisine sığılacak içerik yok',
    dupeLayerName: 'O isimde bir katman zaten var!',
    enterUniqueLayerName: 'Benzersiz bir katman ismi girin',
    enterNewLayerName: 'Yeni katman ismi verin',
    layerHasThatName: 'Katmanın ismi aynı',
    QmoveElemsToLayer: 'Seçilen nesneleri \'%s\' katmanına taşıyın?',
    QwantToClear: 'Çizimi sıfırlamak istediğinizden emin misiniz?\nBu aynı zamanda gerial geçmişini de silecek!',
    QwantToOpen: 'Yeni bir belge açmak istediğinize emin misiniz?\nBu aynı zamanda gerial geçmişini de silecek!',
    QerrorsRevertToSource: 'SVG dosyasını tararken sorunlar oluştu.\nOrjinal SVG dosyasına dönüş yapılsın mı?',
    QignoreSourceChanges: 'SVG kayndağındaki değişiklikleri gözmezden gelelim mi?',
    featNotSupported: 'Bu özellik desteklenmiyor',
    enterNewImgURL: 'Yeni bir resim bağlantısı(URL) girin',
    defsFailOnSave: 'NOTE: internet gezgininizdeki hata nedeni ile, bu resim yanlış görüntülenebilir (gradyan ya da element eksikliği). Ama kaydedildikten sonra düzgün görünecektir.',
    loadingImage: 'Resim yükleniyor, Lütfen bekleyiniz...',
    saveFromBrowser: '\'Farklı Kaydet...\' seçeneğini seçin (sağ tık menüsünden ya da Dosya menüsünden olabilir) eğer bu resmi {{type}} tipinde kaydetmek istiyorsanız.',
    noteTheseIssues: 'Ayrıca şu sorunları not edin: ',
    unsavedChanges: 'Kaydedilmemiş değişiklikler mevcut.',
    enterNewLinkURL: 'Yeni bir bağlantı URL\'si girin',
    errorLoadingSVG: 'Hata: SVG verisi yüklenemiyor',
    URLLoadFail: 'URL\'den yükleme gerçekleştirilemiyor',
    retrieving: 'Alınıyor \'%s\' ...',
    popupWindowBlocked: 'Açılı pencere internet gezgini tarafından engelleniyor olabilir',
    exportNoBlur: 'Bulanık ögeler bulanık değil gibi görüntülenecek',
    exportNoforeignObject: 'foreignObject ögeleri görüntülenmeyecek',
    exportNoDashArray: 'Çizgiler \'sürekli\' görüntülenecek',
    exportNoText: 'Metin beklenildiği şekilde görüntülenmeyebilir',
    editorPreferencesMsg: 'Varsayılan olarak ve destekleniyorsa, SVG-Edit seçimlerinizi ve SVG dosyayı bilgisayarınızda yerel olarak kaydedebilir dolayısıyla SVG-Edit\'i her açtığınızda tekrar yüklemek zorunda değilsiniz. Eğer gizlilik gereği bu özelliği kapatmak isterseniz aşağıdaki seçeneklerden yapabilrisiniz.',
    source_dialog_note: 'Bu kutu içeriğini metin düzenleyiciye kopyalayın, sonra dosyayı .svg eklentisi ile kaydedin.'
  }
}
